import { AloftPrice, isDefined, schAlertType, schPairedCostRouteItem } from '@aloft/toolkit-shared';

import { PropertyGridCellKey } from '../../../../components/PropertyGrid/types.ts';
import { AlertDefinition } from '../../types.ts';
import { getAlertTriggers } from '../utils/alertTriggers.ts';
import { getScopedAlertType } from '../utils/compTypeScoping.ts';

const TARGET_CELL_TOOLTIP = 'Adjustments all in the same direction';
const TIPS =
  'Include Comps with positive and negative adjustments, or explain the one-sided adjustment trend.';
const MESSAGE =
  'Net adjustments across all comparables are made in the same direction. Please add comparable(s) or provide detailed explanation.';

export const allCompsAdjustedSame: AlertDefinition = ({
  compAdjustments,
  compSequence,
  compType,
  order,
}) => {
  const netAdjustments = compSequence
    .map((id) => compAdjustments[id]?.netAdjustment.adjustment)
    .filter(isDefined);

  const allSameDirection =
    netAdjustments.length > 0 &&
    (netAdjustments.every((netAdjustment) => netAdjustment.gt(AloftPrice.zero)) ||
      netAdjustments.every((netAdjustment) => netAdjustment.lt(AloftPrice.zero)));

  if (compSequence.length < 2 || !allSameDirection) return [];

  const fixRoute = schPairedCostRouteItem.enum['adjustments-grid'];
  const firstCompId = compSequence[0];
  const targetCellKey = `${firstCompId}-adjustedSalePrice` as PropertyGridCellKey;

  return [
    {
      type: getScopedAlertType(schAlertType.enum.allCompsAdjustedSame, compType),
      status: 'active',
      severity: 'error',
      orderType: ['appraisify'],
      message: MESSAGE,
      propertyID: firstCompId,
      ...(compType ? { compType } : {}),
      fixingInfo: {
        tips: TIPS,
        pairedCostRouteItem: fixRoute,
        fixingMethod: ['comment', 'action'],
        commentAlwaysRequired: false,
        targetCellKey,
        targetCellTooltip: TARGET_CELL_TOOLTIP,
      },
      triggers: getAlertTriggers({
        fixRoute,
        order,
      }),
    },
  ];
};
